<mat-progress-bar
  mode="indeterminate"
  color="warn"
  [style.display]="loading ? 'block' : 'none'"
/>

<h2 class="m-4"><span class="titulo">Vecinos </span></h2>

<app-graficos-vecinos />

<!-- LISTADO CON CARTAS -->
<div class="table-container mat-elevation-z2">
  <!-- Filtro y columnas -->
  <div class="row justify-between align-center" style="padding: 1em">
    <!-- Filtros -->
    <app-filtro-tabla
      class="flex-1"
      [search]="search"
      [datos]="filtros"
      (onFilterChange)="cambioFiltro($event)"
    />
    <!-- Boton XLS -->
    <button mat-fab matTooltip="Exportar" color="primary" (click)="exportar()">
      XLS
    </button>
  </div>

  <!-- Paginator -->
  <mat-paginator
    #topPaginator
    [length]="totalCount"
    [pageSize]="helper.pageSize"
    [pageSizeOptions]="helper.pageSizeOptions"
    [showFirstLastButtons]="true"
    (page)="pageEvent($event)"
  />

  @if (!loading) {
    <div class="grid">
      @for (c of datos; track c) {
        <div>
          @if (c) {
            <app-carta-vecino [config]="c" />
          }
        </div>
      }
    </div>
  }

  @if (loading) {
    <div class="spinner">
      <mat-spinner />
    </div>
  }

  <!-- Paginator -->
  <mat-paginator
    #botPaginator
    [length]="totalCount"
    [pageSize]="helper.pageSize"
    [pageSizeOptions]="helper.pageSizeOptions"
    [showFirstLastButtons]="true"
    (page)="pageEvent($event)"
  />
</div>
